import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M12 20q-3.35 0-5.675-2.325T4 12t2.325-5.675T12 4q1.725 0 3.3.712A7.6 7.6 0 0 1 18 6.75V5q0-.425.288-.713A.96.96 0 0 1 19 4q.425 0 .713.288.288.289.287.712v5a.97.97 0 0 1-.288.713A.96.96 0 0 1 19 11h-5a.97.97 0 0 1-.713-.288A.96.96 0 0 1 13 10q0-.425.288-.713A.96.96 0 0 1 14 9h3.2a5.84 5.84 0 0 0-2.188-2.2A5.93 5.93 0 0 0 12 6Q9.5 6 7.75 7.75T6 12t1.75 4.25T12 18a5.86 5.86 0 0 0 3.113-.863 5.95 5.95 0 0 0 2.187-2.312q.2-.35.563-.487t.737-.013a.9.9 0 0 1 .575.525q.175.4-.025.75a8.1 8.1 0 0 1-2.925 3.2Q14.325 20 12 20"
    }, null, -1)
  ]))]))
}
export default { render: render }